import React from "react";
import {Box, Typography} from "@mui/material";
import {CryptoIcon, StockIcon} from "../../assets/svgFile";

const stockData = [
  {icon: <StockIcon />, title: "Stocks:", amt: "6,296"},
];

const cryptoData = [
  {icon: <CryptoIcon />, title: "Cryptos:", amt: "22,932"},
];

const HeaderTop = () => {
  return (
    <Box className="headerTop">
      <Box className="topLeftPanel" sx={{display: "flex"}} alignItems="center">
        <Box className="stockSect" display="flex" alignItems="center">
          {stockData.map((stock, key) => (
            <Box key={key} display="flex" alignItems="center" mx={1}>
              {stock.icon}
              <Typography variant="h6">{stock.title}</Typography>
              <Typography variant="h5">{stock.amt}</Typography>
            </Box>
          ))}
        </Box>
        <Box className="stockSect cryptoSect" display="flex" alignItems="center">
          {cryptoData.map((crypto, key) => (
            <Box key={key} display="flex" alignItems="center" mx={1}>
              {crypto.icon}
              <Typography variant="h6">{crypto.title}</Typography>
              <Typography variant="h5">{crypto.amt}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderTop;
